import React, { createContext, useState, useContext, useCallback } from 'react';
import NotificationModal from '../components/NotificationModal';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification deve ser usado dentro de um NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    isOpen: false,
    type: 'info',
    message: '',
    autoClose: true,
    duration: 4000
  });

  // Usando useCallback para evitar recriação desnecessária da função
  const showNotification = useCallback((type, message, autoClose = true, duration = 4000) => {
    
    // Fechamos qualquer notificação existente primeiro
    setNotification(prev => ({ ...prev, isOpen: false }));
    
    // Pequeno timeout para garantir que a transição de fechamento tenha concluído
    setTimeout(() => {
      setNotification({
        isOpen: true,
        type,
        message,
        autoClose,
        duration
      });
    }, 100);
  }, []);

  const closeNotification = useCallback(() => {
    setNotification(prev => ({ ...prev, isOpen: false }));
  }, []);

  // Métodos de atalho para diferentes tipos de notificações
  const success = useCallback((message, autoClose = true, duration = 4000) => 
    showNotification('success', message, autoClose, duration), [showNotification]);
  
  const error = useCallback((message, autoClose = true, duration = 5000) => 
    showNotification('error', message, autoClose, duration), [showNotification]);
  
  const warning = useCallback((message, autoClose = true, duration = 4500) => 
    showNotification('warning', message, autoClose, duration), [showNotification]);
  
  const info = useCallback((message, autoClose = true, duration = 4000) => 
    showNotification('info', message, autoClose, duration), [showNotification]);

  return (
    <NotificationContext.Provider 
      value={{ 
        showNotification, 
        closeNotification,
        success,
        error,
        warning,
        info
      }}
    >
      {children}
      <NotificationModal
        isOpen={notification.isOpen}
        type={notification.type}
        message={notification.message}
        autoClose={notification.autoClose}
        duration={notification.duration}
        onClose={closeNotification}
      />
    </NotificationContext.Provider>
  );
};

export default NotificationContext; 